/**
 * Action for ticket selection of wizard view of a reservation.
 *
 * @class
 */
Sitepackage.Plugin.Reservation.WizardStepReservationInfoAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {WizardAction} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var WizardStepReservationInfoAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        this.plugin = plugin;

        // Parent plugin container
        this.pluginContainer = pluginContainer;

        // Main container of the action
        this.container = container;

        this.reservationDataTemplate = this.container.querySelector('.reservation-data').cloneNode(true);
        this.reservationDataTemplate.classList.remove('reservation-data');


        this.infoField = this.container.querySelector('#guideinfo');
        this.emailField = this.container.querySelector('#email');
        this.sendEmailCheckbox = this.container.querySelector('#emailsenden2');

        //this.initialize();

    };

    WizardStepReservationInfoAction.prototype.initialize = function (callback) {
        const self = this;

        GeneralUtility.showLoadingAnimationOfCard(self.container);

        self.hideHasDataHeader();

        self.infoField.addEventListener('blur', function () {
            self.plugin.setCurrentValue('info', self.infoField.value.trim());
            self.validateStep();
            self.updateHasDataHeader();
        });
        self.emailField.addEventListener('blur', function () {
            self.plugin.setCurrentValue('email', self.emailField.value.trim());
            self.validateStep();
            self.updateHasDataHeader();
        });
        self.sendEmailCheckbox.addEventListener('change', function () {
            self.plugin.setCurrentValue('sendEmail', self.sendEmailCheckbox.checked);
            self.validateStep();
            self.updateHasDataHeader();
        });

        self.prefill(function () {
            self.validateStep();

            GeneralUtility.hideLoadingAnimationOfCard(self.container);

            if (callback && typeof callback === 'function') {
                callback();
            }
        });

    };

    WizardStepReservationInfoAction.prototype.isOpen = function () {
        return this.container.classList.contains('card-active');
    };

    WizardStepReservationInfoAction.prototype.prefill = function (callback) {
        const self = this;
        var currentValues = self.plugin.getCurrentValues();

        self.updateHasDataHeader();
        if (self.hasData() && !self.isOpen()) {
            self.showHasDataHeader();
        }

        if (currentValues.email) {
            self.emailField.value = currentValues.email;
        }

        if (currentValues.info) {
            self.infoField.innerHTML = currentValues.info;
        }


        if (callback && typeof callback === 'function') {
            callback();
        }
    };

    /**
     * Does pre submit tasks and calls callback function afterwards
     *
     * @returns {void}
     */
    WizardStepReservationInfoAction.prototype.preSubmit = function (callback) {
        const self = this;


        if (callback && typeof callback === 'function') {
            callback();
        }


    };

    /**
     * Enables next button if all fields are filled correctly
     *
     * @returns {boolean}
     */
    WizardStepReservationInfoAction.prototype.validateStep = function () {
        const self = this;
        var valid = true;

        validateEmail = function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        if (self.emailField.value.trim().length > 0 && !validateEmail(self.emailField.value.trim())) {
            valid = false;
            self.plugin.showError('email', TYPO3.lang['reservation.wizard.emailError']);
        } else {
            self.plugin.removeError('email');
        }

        //Last step has no nextButton
        /*if(!valid) {
            self.submitContainer.querySelector('.btn-next').setAttribute('disabled', 'disabled');
        } else {
            self.submitContainer.querySelector('.btn-next').removeAttribute('disabled');
        }*/
        self.setValidState(valid);
        self.plugin.toggleStateOfSubmitButton();
        return valid;
    };

    /**
     *
     * @param valid
     */
    WizardStepReservationInfoAction.prototype.setValidState = function (valid) {
        this.isValid = valid;
        this.container.dataset.valid = valid;
    };

    /**
     *
     * @returns {boolean}
     */
    WizardStepReservationInfoAction.prototype.getValidState = function () {
        return this.isValid;
    };

    /**
     *
     * Indicates if data was entered in the step. Used to modify the card header
     *
     * @returns {boolean}
     */
    WizardStepReservationInfoAction.prototype.hasData = function () {
        var currentValues = this.plugin.getCurrentValues();

        if (currentValues.email !== undefined || currentValues.info !== undefined) {
            return true;
        }
        return false;
    };

    /**
     *
     * Hides entered data and shows the generic headline again
     *
     * @returns {void}
     */
    WizardStepReservationInfoAction.prototype.hideHasDataHeader = function () {
        this.container.classList.remove('card-data');

    };

    /**
     *
     * Modifies the card header.
     *
     * @returns {void}
     */
    WizardStepReservationInfoAction.prototype.updateHasDataHeader = function () {
        var currentValues = this.plugin.getCurrentValues();

        var dataContainer = this.container.querySelector('.card-header .reservation-data');
        if (this.hasData()) {

            var template = this.reservationDataTemplate.innerHTML;

            var infoText = currentValues.info;
            if (!infoText) {
                infoText = '';
            }
            if (infoText && infoText.length > 50) {
                infoText = infoText.substring(0, 50) + '...';
            }
            var email = currentValues.email;
            if (!email) {
                email = TYPO3.lang['reservation.wizard.emailEmptyText'];
            }

            template = template.replace(/---field:email---/g, email);
            template = template.replace(/---field:info---/g, info);
            dataContainer.innerHTML = template;
            dataContainer.querySelector('[data-field-value="email"]').innerHTML = email;
            dataContainer.querySelector('[data-field-value="info"]').innerHTML = infoText;
        }

    };

    /**
     *
     * Shows entered data instead of the generic headline
     *
     * @returns {void}
     */
    WizardStepReservationInfoAction.prototype.showHasDataHeader = function () {

        if (this.hasData()) {
            this.container.classList.add('card-data');

        } else {
            this.container.classList.remove('card-data');
        }

    };

    return WizardStepReservationInfoAction;
})();
